// extracted by mini-css-extract-plugin
export default {"logo_hr":"navbar_logo_hr__31-V1","logo_pmjay":"navbar_logo_pmjay__AUEFi","logo_ayush":"navbar_logo_ayush__vCKLR"};